import { render } from "./ToggleButton.vue?vue&type=template&id=5f705497"
import script from "./ToggleButton.vue?vue&type=script&lang=js"
export * from "./ToggleButton.vue?vue&type=script&lang=js"

import "./ToggleButton.vue?vue&type=style&index=0&id=5f705497&lang=scss"

import exportComponent from "C:\\Users\\cheew\\OneDrive\\Desktop\\CE4172\\drum\\drum-webapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__